<template>
  <b-container>
    <b-card no-body class="mt-3">
      <b-tabs card v-model="tabIndex">
        <b-tab title="Choices">
          <div v-if="getQuestions.length>0">
            <b-table responsive striped hover :items="getQuestions" :fields="questionFields">
              <template v-slot:cell(#)="data">{{data.index + 1}}</template>
              <template v-slot:cell(question)="data">{{data.item.question}}</template>
              <template v-slot:cell(action)="data">
                <b-button size="sm" variant="primary" @click="setChoices(data.item)">Show Choices</b-button>
              </template>
            </b-table>
          </div>
        </b-tab>
        <b-tab title="Add New Choice">
          <div>
            <b-form>
              <b-form-group id="input-group-1" label="Enter Question Choice :" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="choice"
                  type="text"
                  required
                  placeholder="Enter question Choice here.."
                ></b-form-input>
              </b-form-group>

              <b-form-group id="input-group-3" label="Question :" label-for="input-3">
                <b-form-select v-model="selectedQuestion">
                  <option
                    v-for="(quest, ind ) in getQuestions"
                    :key="ind"
                    :value="quest"
                  >{{ quest.question }}</option>
                </b-form-select>
              </b-form-group>
              <b-form-group id="input-group-1" label="Enter Choice Marks :" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="marks"
                  type="text"
                  required
                  placeholder="Enter Choice Marks here.."
                ></b-form-input>
              </b-form-group>

              <b-button @click="addOrUpdateChoice" variant="primary">Add Choice</b-button>
            </b-form>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>

    <b-card class="mt-3">
      <b-table responsive head-variant="none" :items="choices" :fields="fields">
        <template v-slot:cell(#)="data">{{data.index + 1}}</template>
        <template v-slot:cell(question)="data">{{data.item.choice}}</template>
        <template v-slot:cell(action)="data">
          <b-button size="sm" variant="info" class="mr-2" @click="editChoice(data.item)">Edit</b-button>
          <b-button
            size="sm"
            :variant="data.item.correctChoice ? 'success' : 'info'"
            class="mr-2"
            @click="correctAnswer(data.item)"
          >{{data.item.correctChoice ?'Remove Correct' :'Make Correct Answer '}}</b-button>
          <b-button size="sm" variant="danger" class="mr-2" @click="deleteChoice(data.item)">Delete</b-button>
        </template>
      </b-table>
    </b-card>
  </b-container>
</template>

<script>
import { db } from "../../db";
export default {
  data() {
    return {
      tabIndex: 0,
      fields: [
        { key: "#", sortable: false },
        { key: "question", sortable: false },
        { key: "action", sortable: false }
      ],
      questionFields: [
        { key: "#", sortable: false },
        { key: "question", sortable: true },
        { key: "action", sortable: false }
      ],
      choices: [],
      marks: "",
      selectedQuestion: null,
      choice: "",
      updateOperation: false,
      choiceId: ""
    };
  },

  computed: {
    getQuestions() {
      return this.$store.getters.getQuestions;
    },
    getChoices() {
      return this.$store.getters.getChoices;
    }
  },

  created() {
    if (this.$store.getters.getQuestions.length == 0) {
      this.$store.dispatch("setQuestions");
    }
    if (this.$store.getters.getChoices.length == 0) {
      this.$store.dispatch("setChoices");
    }
  },
  methods: {
    setChoices(data) {
      this.choices = [];
      this.choices = this.getChoices.filter(el => {
        return el.questionId == data.id;
      });
    },
    addOrUpdateChoice() {
      if (
        this.choice.trim() !== "" &&
        this.selectedQuestion.question.trim() !== ""
      ) {
        if (!this.updateOperation) {
          db.collection("choices").add({
            choice: this.choice,
            questionId: this.selectedQuestion.id,
            correctChoice: false,
            marks: this.marks
          });
        } else {
          db.collection("choices")
            .doc(this.choiceId)
            .update({
              choice: this.choice,
              marks: this.marks,
              questionId: this.selectedQuestion.id
            });
        }
        this.$store.dispatch("setChoices");
        this.resetValues();
      } else {
        alert("Please Enter Choice Text and Select a Question ");
      }
    },
    editChoice(value) {
      this.tabIndex = 1;
      this.choice = value.choice;
      this.selectedQuestion = this.getQuestions.find(ques => {
        return ques.id == value.questionId;
      });
      this.marks = value.marks;
      this.updateOperation = true;
      this.choiceId = value.id;
    },
    correctAnswer(value) {
      db.collection("choices")
        .doc(value.id)
        .update({
          correctChoice: !value.correctChoice
        });
      this.$store.dispatch("setChoices");
    },
    async deleteChoice(data) {
      if (confirm("Are you sure you want to delete choice")) {
        await db
          .collection("choices")
          .doc(data.id)
          .delete();
        this.$store.dispatch("setChoices");
        this.choices = this.choices.filter(cho => {
          return cho.id !== data.id;
        });
      }
    },
    resetValues() {
      this.choice = "";
      this.selectedQuestion = null;
      this.tabIndex = 0;
      this.marks = "";
      this.updateOperation = false;
    }
  }
};
</script>